module.exports = __webpack_public_path__ + "img/airkong.958481ca.png";